import { useEffect, useState, useCallback} from "react";
import { API_ENDPOINT } from '../config.js';

  const useFetch = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);

  const fetchData = useCallback( async (action, method="GET", formData=null) => {
      setLoading(true);
      setError([]);
      setData([]);

      try {
        //const url = `http://erp-backend.mistermobile.sg:8000/api/${action}`;
        const url = `${API_ENDPOINT}/${action}`;
        const token = localStorage.getItem('token');

        let payload = {
            method: method, // or POST, PUT, DELETE, etc.
            headers: {
              'Authorization': `Token ${token}`,
              'Content-Type': 'application/json'
            }
        }

        if(formData){
            payload = {
              method: method, // or POST, PUT, DELETE, etc.
              headers: {
                'Authorization': `Token ${token}`,
                'Content-Type': 'application/json'
              },
              body : JSON.stringify(formData),
            }
        }

        const response = await fetch(url, payload);
        const json = await response.json();
        if(response.ok){
          setData(json);   
        }
        else{
          console.log("Error 1", json);
          setError(json)
        }
      } catch (e) {
         console.log("Error", e);
        setError(e)

      } finally {
        setLoading(false);
      }
     

  }, []);



  return { data, loading, error, fetchData }


} 


export default useFetch;
 